import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Button, Card, CardBody, CardHeader, Container, Input } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import cogoToast from 'cogo-toast';
import ConfirmPricing from '../../../ProgramOnboarding/Components/Comman/Modal/ConfimPricing';
import { ChevronLeft, X } from 'react-feather';
import CustomFilterCard from '../../../ProgramOnboarding/Components/Comman/CustomFilterCard';
import { SAVE_DRAFT_CONFIGURATION, UPDATE_DRAFT_CONFIGURATION } from '../../../../../../../store/actions';
import { useDispatch } from 'react-redux';

const AddVendorPricing = ({ setState, setFormCount, state, isDraftConfiguration, configuration }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [columns, setColumns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [vendorPricingRows, setVendorPricingRows] = useState([]);
  const [currentSelectedRows, setCurrentSelectedRows] = useState([]);
  const [isShowConfirmPricingModal, setIsShowConfirmPricingModal] = useState(false);
  const [columnFilters, setColumnFilters] = useState({
    airport: '',
    zone: '',
    vendor: '',
    carType: '',
    serviceType: '',
    currency: '',
  });

  const [dropdownOpen, setDropdownOpen] = useState({
    airport: false,
    zone: false,
    vendor: false,
    carType: false,
    serviceType: false,
    currency: false,
  });

  const updateFilter = (key, value) => {
    setColumnFilters(prev => ({ ...prev, [key]: value }));
  };

  const clearFilter = key => {
    setColumnFilters(prev => ({ ...prev, [key]: '' }));
  };

  const toggleDropdown = (key: keyof typeof dropdownOpen) => {
    setDropdownOpen(prev => {
      const newState: typeof prev = {
        airport: false,
        zone: false,
        vendor: false,
        carType: false,
        serviceType: false,
        currency: false,
      };

      newState[key] = !prev[key];
      return newState;
    });
  };

  useEffect(() => {
    if (state?.vendorPricing?.pricingDetails?.length > 0) {
      setVendorPricingRows(state.vendorPricing.pricingDetails);
    }
  }, []);

  const updateRowValue = (id, key, value) => {
    setVendorPricingRows(prevRows =>
      prevRows.map((row, i) => {
        if (row?.id === id) {
          return {
            ...row,
            [key]: Number(value),
            ...(row.tag === 'default' ? { tag: 'updated' } : row.tag ? { tag: row.tag } : {}),
          };
        }
        return row;
      }),
    );
  };

  const filteredData = vendorPricingRows.filter(row => {
    return Object.entries(columnFilters).every(([key, value]) => {
      const searchTerm = value.toLowerCase();

      if (!value) return true;

      const fieldValue = row[key];

      if (typeof fieldValue === 'string') {
        // Direct string field (e.g. carType, currency, serviceType)
        return fieldValue.toLowerCase().startsWith(searchTerm);
      }

      // For nested objects like airport, zone, etc. that have `name`
      if (fieldValue?.name) {
        return fieldValue.name.toLowerCase().startsWith(searchTerm);
      }

      return false; // default if field not matched
    });
  });

  const getUniqueValues = key => {
    let values;
    if (key === 'serviceType' || key === 'currency') {
      values = vendorPricingRows.map(row => row[key]).filter((v, i, arr) => v && arr.indexOf(v) === i);
    } else values = vendorPricingRows.map(row => row[key]?.name).filter((v, i, arr) => v && arr.indexOf(v) === i);
    return values;
  };

  const createFilterHeader = (label, key) => (
    <div className="d-flex flex-column">
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          background: '#e9ebec',
          color: 'black',
          cursor: 'pointer',
          padding: '2px 4px',
        }}
        onClick={() => toggleDropdown(key)}
      >
        {label}
        {columnFilters[key] && (
          <span
            onClick={e => {
              e.stopPropagation();
              clearFilter(key);
            }}
          >
            <X size={14} color="red" style={{ marginLeft: '4px' }} />
          </span>
        )}
        <i className="ri-arrow-down-s-line fs-14 ms-1" />
      </div>
      <CustomFilterCard
        visible={dropdownOpen[key]}
        onClose={() => toggleDropdown(key)}
        filterKey={key}
        filterValue={columnFilters[key]}
        onChange={updateFilter}
        options={getUniqueValues(key)}
      />
    </div>
  );

  useEffect(() => {
    const fetchColumns = [
      {
        name: 'S.No.',
        cell: (row, index) => (currentPage - 1) * perPage + index + 1,
        width: '80px',
        center: true,
      },
      {
        name: createFilterHeader('Airport Name', 'airport'),
        selector: row => row.airport?.name,
        wrap: true,
        cell: row => row.airport?.name,
        width: '200px',
      },
      {
        name: createFilterHeader('Zone', 'zone'),
        selector: row => row.zone?.name,
        wrap: true,
        width: '100px',
      },
      {
        name: createFilterHeader('Vendor Name', 'vendor'),
        selector: row => row.vendor?.name,
        wrap: true,
        width: '150px',
      },
      {
        name: createFilterHeader('Car Type', 'carType'),
        selector: row => row.carType?.name,
        wrap: true,
        width: '150px',
      },
      {
        name: createFilterHeader('Service Type', 'serviceType'),
        selector: row => row.serviceType,
        wrap: true,
        width: '150px',
      },
      {
        name: createFilterHeader('Currency', 'currency'),
        selector: row => row.currency,
        wrap: true,
        width: '150px',
      },
      {
        name: 'Base Price',
        cell: (row, index) => {
          return (
            <Input
              type="number"
              value={row?.basePrice ?? ''}
              className="form-control"
              required
              onChange={e => updateRowValue(row?.id, 'basePrice', e.target.value)}
              onWheel={(e: any) => e.target.blur()} // Disable number scrolling
            />
          );
        },
        width: '150px',
      },
      {
        name: 'Parking Fee',
        width: '150px',
        cell: (row, index) => {
          return (
            <Input
              type="number"
              value={row?.parkingFee ?? ''}
              className="form-control"
              required
              onChange={e => updateRowValue(row?.id, 'parkingFee', e.target.value)}
              onWheel={(e: any) => e.target.blur()} // Disable number scrolling
            />
          );
        },
      },
    ];

    setColumns(fetchColumns);
  }, [currentPage, perPage, vendorPricingRows, dropdownOpen, columnFilters]);

  const handleRowSelected = state => {
    setCurrentSelectedRows(state?.selectedRows);
  };

  const handleSubmit = () => {
    if (vendorPricingRows.length === 0) {
      cogoToast.error('Please add at least one pricing row.');
      return;
    }

    const hasInvalid = vendorPricingRows.some(row => !row.basePrice || row.parkingFee == null);
    if (hasInvalid) {
      cogoToast.error('Please fill both Base Price and Parking Fee for all rows.');
      return;
    }
    setIsShowConfirmPricingModal(true);
  };

  const breadcrumNavigationHandler = title => {
    if (title === 'Dashboard') {
      history.push('/dashboard');
    }
  };

  const handleDeleteRows = () => {
    setVendorPricingRows(prevRows => {
      const selectedIdSet = new Set(currentSelectedRows.map(item => item.id));
      const newRows = prevRows.filter(item => !selectedIdSet.has(item.id));
      const deletedCount = prevRows.length - newRows.length;
      cogoToast.success(`${deletedCount} row${deletedCount !== 1 ? 's' : ''} deleted`);
      return newRows;
    });
    setCurrentSelectedRows([]);
  };

  const saveAsDraftHandler = () => {
    if (vendorPricingRows.length === 0) {
      cogoToast.error('Please add at least one pricing row.');
      return;
    }
    const hasInvalid = vendorPricingRows.some(row => !row.basePrice || row.parkingFee == null);
    if (hasInvalid) {
      cogoToast.error('Please fill both Base Price and Parking Fee for all rows.');
      return;
    }

    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        pricingDetails: vendorPricingRows,
      },
    }));

    dispatch({
      type: SAVE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            benefit: {
              name: 'Airport Transfer',
            },
            multiProjects: state?.multiProjects,
            vendorPricing: {
              ...state?.vendorPricing,
              pricingDetails: vendorPricingRows,
            },
            page: 7,
          },
          configuration_type: 'vendor_onboarding',
          status: 'DRAFT',
        },
      },
    });
  };

  const updateAsDraftHandler = () => {
    if (vendorPricingRows.length === 0) {
      cogoToast.error('Please add at least one pricing row.');
      return;
    }
    const hasInvalid = vendorPricingRows.some(row => !row.basePrice || row.parkingFee == null);
    if (hasInvalid) {
      cogoToast.error('Please fill both Base Price and Parking Fee for all rows.');
      return;
    }

    setState(prev => ({
      ...prev,
      vendorPricing: {
        ...prev?.vendorPricing,
        pricingDetails: vendorPricingRows,
      },
    }));

    dispatch({
      type: UPDATE_DRAFT_CONFIGURATION,
      payload: {
        data: {
          configuration_data: {
            benefit: {
              name: 'Airport Transfer',
            },
            multiProjects: state?.multiProjects,
            vendorPricing: {
              ...state?.vendorPricing,
              pricingDetails: vendorPricingRows,
            },
            page: 7,
          },
          configuration_type: 'vendor_onboarding',
          status: 'DRAFT',
          id: configuration?.id,
        },
      },
    });
  };

  return (
    <div className="page-content">
      {isShowConfirmPricingModal && (
        <ConfirmPricing
          onClose={() => setIsShowConfirmPricingModal(false)}
          handleYes={() => {
            setState(prev => ({
              ...prev,
              vendorPricing: {
                ...prev?.vendorPricing,
                pricingDetails: vendorPricingRows,
              },
            }));
            setFormCount(prev => prev + 1);
            setIsShowConfirmPricingModal(false);
          }}
        />
      )}

      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <BreadcrumbTrail
            title="Airport Configuration Setup"
            navigationby={breadcrumNavigationHandler}
            navigation={['Management', 'Program', 'Onboarding', 'Vendor Pricing List']}
          />
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="m-0 fw-semibold px-3">Pricing List</h5>
            {currentSelectedRows?.length > 0 && (
              <Button
                className="overlay-disable d-flex align-items-center gap-1"
                style={{ width: '127px' }}
                color="primary"
                onClick={handleDeleteRows}
              >
                <i className="ri-delete-bin-6-line"></i>
                <span>Delete Rows</span>
              </Button>
            )}
          </CardHeader>
          <CardBody>
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              paginationPerPage={perPage}
              onChangePage={page => setCurrentPage(page)}
              onChangeRowsPerPage={(newPerPage, page) => {
                setPerPage(newPerPage);
                setCurrentPage(page);
              }}
              fixedHeader
              fixedHeaderScrollHeight="400px"
              selectableRows
              highlightOnHover
              striped
              persistTableHead
              onSelectedRowsChange={handleRowSelected}
            />
          </CardBody>
        </Card>

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount(prev => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC',
              color: '#404B7C',
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>

          <div className="d-flex gap-2">
            {isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '150px' }} color="primary" onClick={updateAsDraftHandler}>
                Update As Draft
              </Button>
            )}

            {!isDraftConfiguration && (
              <Button className="btn btn-success" style={{ width: '130px' }} color="primary" onClick={saveAsDraftHandler}>
                Save As Draft
              </Button>
            )}

            <Button className="overlay-disable" style={{ width: '250px' }} color="primary" onClick={handleSubmit}>
              Save & Continue
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AddVendorPricing;
